import { Environ, NodeEnvType } from "./types";

const getEnv = (): Environ | undefined => {
  if (process.env.NODE_ENV === NodeEnvType.TEST.toString()) {
    return Environ.TEST;
  }

  if (ENVIRON) return ENVIRON as Environ;
  return undefined;
};

export default getEnv;
